// extracted by mini-css-extract-plugin
export default {"dropZoneBlock":"DropZoneFile_dropZoneBlock__lTq2m","dropDownTitle":"DropZoneFile_dropDownTitle__MqJHL"};